import { ThemeColors } from '@/src/context/ThemeContext';
import { StyleSheet } from 'react-native';

export const createStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    container: {
      flexGrow: 1,
      backgroundColor: 'transparent',
      paddingBottom: 20,
    },
    scroll: {
      flex: 1,
      backgroundColor: 'transparent',
    },
    header: {
      paddingHorizontal: 20,
      paddingTop: 20,
      paddingBottom: 16,
      backgroundColor: colors.surface,
      borderBottomWidth: 1,
      borderBottomColor: colors.border,
    },
    greeting: {
      fontSize: 22,
      fontWeight: '700',
      color: colors.text,
      marginBottom: 12,
    },
    quickActions: {
      flexDirection: 'row',
      gap: 10,
    },
    quickActionBtn: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 6,
      paddingVertical: 10,
      paddingHorizontal: 14,
      borderRadius: 10,
      backgroundColor: colors.primary,
    },
    quickActionBtnSecondary: {
      backgroundColor: colors.surface,
      borderWidth: 1,
      borderColor: colors.border,
    },
    quickActionText: {
      fontSize: 14,
      fontWeight: '600',
      color: colors.primaryText,
    },
    quickActionTextSecondary: {
      color: colors.text,
    },
    section: {
      marginTop: 20,
    },
    sectionHeader: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingHorizontal: 20,
      marginBottom: 8,
    },
    sectionTitle: {
      fontSize: 17,
      fontWeight: '700',
      color: colors.text,
    },
    seeAllBtn: {
      paddingVertical: 4,
      paddingHorizontal: 8,
    },
    seeAllText: {
      fontSize: 14,
      fontWeight: '500',
      color: colors.primary,
    },
    pendingActionsContainer: {
      paddingHorizontal: 16,
      gap: 8,
    },
    pendingActionCard: {
      flexDirection: 'row',
      alignItems: 'center',
      padding: 14,
      borderRadius: 12,
      borderWidth: 1,
      borderColor: colors.border,
      backgroundColor: colors.card,
      gap: 12,
    },
    pendingActionIconContainer: {
      width: 36,
      height: 36,
      borderRadius: 18,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: colors.primary + '22',
    },
    pendingActionText: {
      flex: 1,
      fontSize: 14,
      fontWeight: '500',
      color: colors.text,
    },
    pendingActionChevron: {},
    emptyCard: {
      marginHorizontal: 16,
      padding: 20,
      borderRadius: 12,
      borderWidth: 1,
      borderColor: colors.border,
      backgroundColor: colors.card,
      alignItems: 'center',
      gap: 8,
    },
    emptyCardText: {
      fontSize: 14,
      color: colors.textSecondary,
      textAlign: 'center',
    },
    emptyCardAction: {
      fontSize: 14,
      fontWeight: '600',
      color: colors.primary,
      marginTop: 4,
    },
    gettingStartedCard: {
      marginHorizontal: 16,
      borderRadius: 16,
      borderWidth: 1,
      borderColor: colors.primary + '44',
      backgroundColor: colors.primary + '0D',
      overflow: 'hidden',
    },
    gettingStartedHeader: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 10,
      paddingHorizontal: 16,
      paddingTop: 16,
      paddingBottom: 12,
    },
    gettingStartedTitle: {
      fontSize: 15,
      fontWeight: '700',
      color: colors.text,
    },
    gettingStartedItem: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 12,
      paddingHorizontal: 16,
      paddingVertical: 12,
      borderTopWidth: 1,
      borderTopColor: colors.border,
    },
    gettingStartedIconWrap: {
      width: 36,
      height: 36,
      borderRadius: 18,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: colors.primary + '22',
    },
    gettingStartedItemText: {
      flex: 1,
      fontSize: 14,
      fontWeight: '500',
      color: colors.text,
    },
    bottomPadding: {
      height: 40,
    },
  });
